import { fromEvent, map, Observable, startWith, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';

// custom operator based on: https://rxjs.dev/guide/operators#creating-new-operators-from-scratch
export function skipIfNotVisible<T>(emitDirectlyWhenBecomingVisible: boolean = true) {
  return (observable: Observable<T>) =>
    new Observable<T>((subscriber) => {
      let innerObservable: Observable<T>;
      if (emitDirectlyWhenBecomingVisible) {
        const isVisible$ = fromEvent(document, 'visibilitychange').pipe(
          map(() => document.visibilityState),
          startWith(document.visibilityState),
          map((visibilityState) => visibilityState === 'visible')
        );
        innerObservable = combineLatest([observable, isVisible$]).pipe(
          filter(([, isVisible]) => isVisible),
          map(([originalObs]) => originalObs)
        );
      } else {
        innerObservable = observable.pipe(filter(() => document.visibilityState === 'visible'));
      }
      const subscription = innerObservable.subscribe({
        next(value) {
          subscriber.next(value);
        },
        error(err) {
          // We need to make sure we're propagating our errors through.
          subscriber.error(err);
        },
        complete() {
          subscriber.complete();
        },
      });

      // Return the finalization logic. This will be invoked when
      // the result errors, completes, or is unsubscribed.
      return () => {
        subscription.unsubscribe();
      };
    });
}
